import {
    Combobox,
    ComboboxChip,
    ComboboxChips,
    ComboboxChipsInput,
    ComboboxEmpty,
    ComboboxItem,
    ComboboxList,
    ComboboxPopup,
    ComboboxValue,
} from "@/components/ui/combobox";

export type AccountObjectsComboboxProps = {
    disabled?: boolean;
    name: string;
    items: { value: string; label: string }[];
    defaultValues?: string[];
    emptyValue?: string;
    filterLabel?: string;
    filterPlaceholder?: string;
};

export function AccountObjectsCombobox({
    disabled,
    name,
    items,
    defaultValues,
    emptyValue,
    filterLabel,
    filterPlaceholder,
}: AccountObjectsComboboxProps) {
    const defaultItems = items.filter((item) => defaultValues?.includes(item.value));
    return (
        <Combobox
            disabled={disabled}
            items={items}
            name={name}
            defaultValue={defaultItems}
            itemToStringValue={(item) => item.value}
            multiple
        >
            <ComboboxChips>
                <ComboboxValue>
                    {(value: { value: string; label: string }[]) => (
                        <>
                            {value?.map((item) => (
                                <ComboboxChip aria-label={item.label} key={item.value}>
                                    {item.label}
                                </ComboboxChip>
                            ))}
                            <ComboboxChipsInput
                                aria-label={filterLabel}
                                placeholder={value.length > 0 ? undefined : filterPlaceholder}
                            />
                        </>
                    )}
                </ComboboxValue>
            </ComboboxChips>
            <ComboboxPopup>
                <ComboboxEmpty>{emptyValue || "No results"}</ComboboxEmpty>
                <ComboboxList>
                    {(item) => (
                        <ComboboxItem key={item.value} value={item}>
                            {item.label}
                        </ComboboxItem>
                    )}
                </ComboboxList>
            </ComboboxPopup>
        </Combobox>
    );
}
